import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppMainService } from 'src/app/app-main.service';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { SavedSearchNS } from '../../models/saved-search.models';
import { Subject, takeUntil } from 'rxjs';
import { ISavedSearchColumnModel } from '../../models/saved-search-filter.model';
import { ColumnSettingsN } from 'src/app/modules/shared/models/column-settings.model';
import { ActivityModuleId} from 'src/app/modules/shared/constants/modules.constant';
import { ActivityCommaSeparatedControls, CSVControls, CommaSeparatedControls } from 'src/app/modules/shared/constants/formcontrol-list.constants';
import { MessageService } from 'primeng/api';
import { SavedSearchesService } from '../../services/saved-searches.service';
import { Impact } from './impact';
import { DynamicTableService } from 'src/app/modules/shared/services/dynamic-table/dynamic-table.service';
import { SavedSearchRecordService } from '../../services/saved-search-record.service';
@Component({
  selector: 'app-predict',
  templateUrl: './predict.component.html',
  styleUrls: ['./predict.component.scss']
})
export class PredictComponent implements OnInit, OnChanges {
  impact: any;
  @Input() display;
  @Input() selectedSearch?: SavedSearchNS.ISavedSearchOverview;
  @Input() selectedWorkbookColumn?: any;
  @Input() selectedWorkbookId? : string;
  @Output() dialogClosed = new EventEmitter<boolean>();
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  pageIndex = 1;
  listLabel = [
    { label: 'Predict', value: 'predict' }, { label: 'Ignore', value: 'ignore' }
  ]
  selectedLabel: string;
  preidctList: any[] = [];
  // selectedPredict: ISavedSearchColumnModel | null = null;  //Need to fix interface important.
  selectedPredict: any | null = null;
  // selectedDate: ISavedSearchColumnModel | null = null; //Need to fix interface important.
  selectedDate: any | null = null;
  ignoreList: any[] = [];
  selectedIgnore;
  data: any[];
  layout: any;
  data1: any[];
  layout1: any;
  data2: any[];
  layout2: any;
  data3: any[];
  layout3: any;
  data4: any[];
  layout4: any;
  data5: any[];
  layout5: any;
  data6: any[];
  layout6: any;
  data7: any[];
  layout7: any;
  data8: any[];
  layout8: any;
  embeddingsPlotID;
  predictionSegmentPlots: Array<{ data: any, layout: any }> = [];
  //char
  barData = {
    labels: [''],
    datasets: [
      {
        label: 'Model',
        backgroundColor: 'hsl(233, 85.9%, 66.7%)',
        data: [20.38]
      },
      {
        label: 'Baseline',
        backgroundColor: '#bdd9fb',
        data: [20.30]
      }
    ]
  };

  columns: ISavedSearchColumnModel[] = [];
  dateColumns: ISavedSearchColumnModel[] = [];
  selectedForecastDate: ISavedSearchColumnModel | null = null;
  nonDateColumns: ISavedSearchColumnModel[] = [];

  locations = [
    { id: 1, name: "Asia" },
    { id: 2, name: "India" },
    { id: 3, name: "China" },
    { id: 4, name: "USA" },
  ];
  selectedLocation;
  selectedImpact: any;
  predictionResult: any = Impact;
  forecastResult: any = Impact;
  analysisType:any = Impact;
  predictionResultCategory: any;
  forecastingResultCategory: any;
  secondForecasting: any;
  thirdForecasting: any;
  fourthForecasting: any;
  fifthForecasting: any;
  section5: any;
  selectedSeasonality: string = 'quarterly';
  categoryList: any[] = [];
  selectedCategory: any;
  predictionPerformanceBlock: any;
  predictionEstimation: any;
  chartData: any;
  showPredictionBtn: boolean = false;
  isShowDetails = false;
  btnDisable: boolean = false;
  factors: any[] = [];
  activeCard: 'accuracy' | 'rmse' | 'mae' = 'accuracy';
  futureArray: { date: string, value: number }[] = [];
  displayModal: boolean = false;
  selectedImage: string;
  chartDescription: string[] = [];
  predictionSegmentBlock: any;
  segment: any[] = [];
  sampleColumns: any[] = [];   // Holds the column names (headers)
  sampleRows: any[] = [];      // Holds the row data (values)
  predictionRows: { value: number }[] = [];
  showDialog: boolean = false;
  /**Workbook variables */
  selectedWorkbookDateColumn:any[]=[];
  selectedWorkbookNonDateColumn:any[]=[];
  /**Status Variable */
  isModelTraining: boolean = false;
  modelStatus: 'pending' | 'success' | null = null;
  isLoading: boolean = true;
  userInputRows:any[] = [];
  userPredictionRows:any[]= [];
  savedSearchRowsCount: number = 0;


  
  constructor(
    private appMainService: AppMainService,
    private sharedColumnSettingsService: SharedColumnSettingsService,
    private messageService: MessageService,
    private savedSearchesService: SavedSearchesService,
    public dynamicTableService: DynamicTableService,
    private SavedSearchRecordService: SavedSearchRecordService
  ) { }

  ngOnInit(): void {
    this.filterDateColumns();
    if(!this.selectedWorkbookId){ 
      this.getSavedSearchRowCount();
    }
  }

  ngOnChanges(changes: SimpleChanges) {     
    if (changes?.selectedSearch && changes?.selectedSearch?.currentValue) {
      this.selectedSearch = changes.selectedSearch.currentValue;
      if (this.selectedSearch?.savedSearchColumnSetting) {
        this.selectedSearch.columns = this.getColumnSettingsForTable(this.selectedSearch.savedSearchColumnSetting);
        this.columns = this.selectedSearch.columns;
      }
      if (this.selectedSearch?.savedSearchColumnSetting) {
        this.selectedSearch.dateColumns = this.getColumnSettingsForTable(this.selectedSearch.savedSearchColumnSetting);
        this.dateColumns = this.selectedSearch.dateColumns;
      }
      if (this.selectedSearch?.savedSearchColumnSetting) {
        this.selectedSearch.nonDateColumns = this.getColumnSettingsForTable(this.selectedSearch.savedSearchColumnSetting);
        this.nonDateColumns = this.selectedSearch.nonDateColumns;
      }

      else {
        this.getColumnSettings();
      }
      if (changes?.display && changes?.display?.currentValue) {
        this.display = changes?.display?.currentValue;
      }
    }
    if(this.selectedWorkbookId){
      this.filterWorkbookColumns();
    }
  }

  getSavedSearchRowCount() {
    this.SavedSearchRecordService.totalRecords$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((count) => {
      this.savedSearchRowsCount = count;
    });
    } 

  filterWorkbookColumns() {
    this.selectedWorkbookDateColumn = this.selectedWorkbookColumn.filter(column => 
      column.formControlName === "DatePicker" || column.formControlName === "DateTimePicker"
    );
    
    
    this.selectedWorkbookNonDateColumn = this.selectedWorkbookColumn.filter(column => 
      column.formControlName !== "DatePicker" && column.formControlName !== "DateTimePicker",
    
    );
  }

  getColumnSettings(): void {
    this.appMainService.isShowSpinner('getColumnSettings');
    this.sharedColumnSettingsService.getColumnSettingsForSavedSearch(this.selectedSearch.objectId, this.selectedSearch.channelId, this.selectedSearch?.id)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        {
          next: (response) => {
            this.selectedSearch.columns = this.getLAColumnSettingsForTable(response);
            this.columns = this.selectedSearch.columns;
            this.selectedSearch.dateColumns = this.getLAColumnSettingsForTable(response);
            this.dateColumns = this.selectedSearch.dateColumns;
            this.filterDateColumns();
            this.appMainService.isHideSpinner('getColumnSettings');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getColumnSettings');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
            });
          },
          complete: () => {

          },
        });
  }

  setActiveCard(card: 'accuracy' | 'rmse' | 'mae') {
    this.activeCard = card;
  }

  showImage(imageUrl: string, chartDescription: string) {
    this.selectedImage = imageUrl;
    this.chartDescription = Array.isArray(chartDescription)
    ? chartDescription
    : this.formatDescription(chartDescription);
    this.displayModal = true;
  }

  showImage1(imageUrl: string, chartDescription: string): void {
    this.selectedImage = imageUrl;
    this.chartDescription = this.formatDescription(chartDescription);
    this.displayModal = true;
  }

  formatDescription(description: string): string[] {
    if (description?.length>0) {
        return description
            .split('\n')
            .map(line => line.trim())
            .filter(line => line !== '')
    }
    return [];
  }

  getFormattedDescription(description: string): string[] {
    return this.formatDescription(description);
  }

  getSavedData() {
    this.savedSearchesService.saveSearchModelData(this.selectedSearch?.id).subscribe((response) => {
      if (response && response.length > 0) {
        // Process successful models
        const lastTrainedModel = response
          .filter(model => {
            if (this.selectedLabel === 'predict') {
              return model.type === 'Prediction' && model.status === 'Success';
            } else {
              return model.type === 'Forecasting' && model.status === 'Success';
            }
          })
          .sort((a, b) => {
            return new Date(b.analysisDate).getTime() - new Date(a.analysisDate).getTime();
          })[0];

        // Check for error message in the latest model
        const latestModel = response.sort((a, b) => {
          return new Date(b.analysisDate).getTime() - new Date(a.analysisDate).getTime();
        })[0];

        if (latestModel && !latestModel.analysis && latestModel.message) {
          // Show error message in toast
          this.messageService.add({
            severity: 'error',
            summary: 'Model Training Error',
            detail: latestModel.message,
            life: 5000
          });
          this.showPredictionBtn = false;
          this.btnDisable = false;
          return;
        }

        if (lastTrainedModel) {
          this.analysisType = lastTrainedModel.type;
          
          if (this.selectedLabel === 'predict' && this.analysisType === 'Prediction') {
            this.showPredictionBtn = true;
            this.btnDisable = false;
            this.loadPredictionModelData(lastTrainedModel);
          } else if (this.selectedLabel === 'forecast' && this.analysisType === 'Forecasting') {
            this.showPredictionBtn = true;
            this.btnDisable = false;
            this.loadForecastingModelData(lastTrainedModel);
          } else {
            this.showPredictionBtn = false;
            this.btnDisable = false;
          }
        } else {
          this.showPredictionBtn = false;
          this.btnDisable = false;
          this.changePredict();
        }
      } else {
        this.showPredictionBtn = false;
        this.btnDisable = false;
        this.changePredict();
      }
    });
  }

  getSavedWorkbookData() {
    this.dynamicTableService.getWorkbookAnalytics(this.selectedWorkbookId).subscribe((response) => {
      if (response && response.length > 0) {
        const updatedData = response.map(item => {
          item.savedSearchId = item.dynamicTableId;
          delete item.dynamicTableId;
          return item;
        });

        // Check for error message in the latest model
        const latestModel = updatedData.sort((a, b) => {
          return new Date(b.analysisDate).getTime() - new Date(a.analysisDate).getTime();
        })[0];

        if (latestModel && !latestModel.analysis && latestModel.message) {
          // Show error message in toast
          this.messageService.add({
            severity: 'error',
            summary: 'Model Training Error',
            detail: latestModel.message,
            life: 5000
          });
          this.showPredictionBtn = false;
          this.btnDisable = false;
          return;
        }

        // Process successful models
        const lastTrainedModel = updatedData
          .filter(model => {
            if (this.selectedLabel === 'predict') {
              return model.type === 'Prediction' && model.status === 'Success';
            } else {
              return model.type === 'Forecasting' && model.status === 'Success';
            }
          })
          .sort((a, b) => {
            return new Date(b.analysisDate).getTime() - new Date(a.analysisDate).getTime();
          })[0];

        if (lastTrainedModel) {
          this.analysisType = lastTrainedModel.type;
          
          if (this.selectedLabel === 'predict' && this.analysisType === 'Prediction') {
            this.showPredictionBtn = true;
            this.btnDisable = false;
            this.loadPredictionModelData(lastTrainedModel);
          } else if (this.selectedLabel === 'forecast' && this.analysisType === 'Forecasting') {
            this.showPredictionBtn = true;
            this.btnDisable = false;
            this.loadForecastingModelData(lastTrainedModel);
          } else {
            this.showPredictionBtn = false;
            this.btnDisable = false;
          }
        } else {
          this.showPredictionBtn = false;
          this.btnDisable = false;
          this.changePredict();
        }
      } else {
        this.showPredictionBtn = false;
        this.btnDisable = false;
        this.changePredict();
      }
    });
  }

  loadPredictionModelData(savedData: any) {
    this.predictionResult = JSON.parse(savedData?.analysis);
    this.loadInferencingModalData(savedData)
    if(this.selectedWorkbookId){
      this.selectedPredict = this.selectedWorkbookColumn?.find((data) => {
        return data.name == this.predictionResult?.targetColumn
      });
    }
    else{
      this.selectedPredict = this.columns?.find((data) => {
        return data.header == this.predictionResult?.targetColumn //For saved search
      });
        
    }
    this.predictionType = this.predictionResult?.predictType || '';
    // this.predictionResult.evaluation = `data:image/png;base64,${this.predictionResult?.evaluation}`
    if (this.predictionResult?.evaluation){
      const dataSet = JSON.parse(this.predictionResult?.evaluation)
      this.data8 = dataSet.data
      this.layout8 = dataSet.layout;
    }
    if (this.predictionType == 'Classification') {
      this.categoryList = (this.predictionResult?.category).map((data) => {
        return { name: data.categoryName }
      });
      this.selectedCategory = this.categoryList[0];
    }
    this.predictionResultCategory = this.predictionResult?.category[0];
    this.impact = this.predictionResultCategory?.impact;
    this.predictionPerformanceBlock = this.predictionResultCategory?.performanceBlock;
    this.predictionSegmentBlock = this.predictionResultCategory?.segment;
    if (this.predictionSegmentBlock && this.predictionSegmentBlock.length > 0) {
      this.predictionSegmentBlock = this.predictionSegmentBlock.map(segment => {
        if (segment?.plot) {
          const dataSet = JSON.parse(segment?.plot);
          return {
            ...segment,
            plotData: dataSet.data,
            plotLayout: dataSet.layout
          };
        }
        return segment;
      });
    }
    if (this.predictionPerformanceBlock?.distribution_plot) {
      const dataSet = JSON.parse(this.predictionPerformanceBlock?.distribution_plot)
      this.data5 = dataSet.data
      this.layout5 = dataSet.layout
    }
    if (this.predictionResultCategory?.evaluation?.prediction_performance) {
      const dataSet = JSON.parse(this.predictionResultCategory?.evaluation?.prediction_performance)
      this.data6 = dataSet.data
      this.layout6 = dataSet.layout
    }
    if (this.segment && this.segment.length > 0 && this.segment[0]?.plot) {
      const dataSet = JSON.parse(this.segment[0]?.plot)
      this.data7 = dataSet.data
      this.layout7 = dataSet.layout
    }
    if (this.predictionResult?.category?.[0]?.sampleRows?.Sample) {
      const sampleData = this.predictionResult.category[0].sampleRows.Sample;
      this.sampleColumns = sampleData.map(item => item.name);
      const numberOfRows = sampleData[0].values.length;
      this.sampleRows = [];
      for (let i = 0; i < numberOfRows; i++) {
        const rowData: any = {};
        sampleData.forEach((column, colIndex) => {
          if (column.name.toLowerCase().includes('date')) {
            try {
              const date = new Date(column.values[i]);
              if (!isNaN(date.getTime())) {
                rowData[column.name] = date.toLocaleDateString();
              } else {
                rowData[column.name] = column.values[i];
              }
            } catch {
              rowData[column.name] = column.values[i];
            }
          }
          else if (typeof column.values[i] === 'number') {
            rowData[column.name] = column.values[i].toLocaleString();
          }
          else if (column.name.includes('Amount') || column.name.includes('Sub Total')) {
            const numValue = parseFloat(column.values[i]);
            if (!isNaN(numValue)) {
              rowData[column.name] = numValue.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              });
            } else {
              rowData[column.name] = column.values[i];
            }
          }
          else {
            rowData[column.name] = column.values[i];
          }
        });
        this.sampleRows.push(rowData);
      }
    }
    if (this.predictionResult?.category?.[0]?.prediction?.value) {
      this.predictionRows = this.predictionResult?.category?.[0]?.prediction?.value.map(value => ({
        value: value
      }));
    }
    this.predictionEstimation = this.predictionResultCategory?.evaluation;
    this.factors = this.predictionResultCategory?.factor;
    this.selectedImpact = this.impact[0];
  }

  loadForecastingModelData(savedData: any) {
    this.forecastResult = JSON.parse(savedData?.analysis);
    if (this.selectedWorkbookId) {
      this.selectedPredict = this.selectedWorkbookColumn?.find((data) => {
        return data.name == this.forecastResult?.targetColumn
      });
    } else {
      this.selectedPredict = this.columns?.find((data) => {
        return data.header == this.forecastResult?.targetColumn
      });
    }
   
    this.forecastingType = this.forecastResult?.predictType || '';
    this.selectedDate = this.dateColumns?.find((data) => {
      return data.header == this.forecastResult?.dateColumn
    });
    this.forecastingType = this.forecastResult?.predictType || '';
    this.forecastingResultCategory = this.forecastResult.category[0];
    this.showPredictionBtn = true;

    if (this.forecastingResultCategory?.firstBlock?.forecasting) {
      const dataSet= JSON.parse(this.forecastingResultCategory?.firstBlock?.forecasting)
      this.data = dataSet.data
      this.layout = dataSet.layout
    }
    this.secondForecasting = this.forecastingResultCategory?.secondBlock;
    if (this.secondForecasting?.plot) {
      const dataSet = JSON.parse(this.secondForecasting?.plot)
      this.data1 = dataSet.data
      this.layout1 = dataSet.layout
    }
    this.thirdForecasting = this.forecastingResultCategory?.thirdBlock;
    if (this.thirdForecasting?.future_forecasting) {
      const dataSet = JSON.parse(this.thirdForecasting?.future_forecasting)
      this.data2 = dataSet.data
      this.layout2 = dataSet.layout
    }
    this.fourthForecasting = this.forecastingResultCategory?.fourthBlock;
    this.futureArray = this.fourthForecasting?.future_values;
    this.futureArray = Object.keys(this.futureArray).map(date => ({
      date: date,
      value: this.futureArray[date]
    }));
    this.section5 = this.fourthForecasting?.seasonality;
    if (this.section5?.monthly) {
      const dataSet = JSON.parse(this.section5?.monthly)
      this.data3 = dataSet.data
      this.layout3 = dataSet.layout
    }
    if (this.section5?.quarterly) {
      const dataSet = JSON.parse(this.section5?.quarterly)
      this.data4 = dataSet.data
      this.layout4 = dataSet.layout
    }
  }

  loadInferencingModalData(savedData:any){
    if(savedData.inferenceAnalysis){
      const inferencingData = JSON.parse(savedData?.inferenceAnalysis);
      this.userInputRows = inferencingData
      this.userInputRows = structuredClone(this.userInputRows);
      this.userPredictionRows = inferencingData?.map(item => {
        return { prediction: item.prediction };
    });
      this.userPredictionRows = structuredClone(this.userPredictionRows)
    }
  }

  getLAColumnSettingsForTable(selectedColums: Partial<ColumnSettingsN>): any[] {
    let columns: ISavedSearchColumnModel[] = [];
    let dateColumn: ISavedSearchColumnModel[] = [];
    if (selectedColums.listViewSections) {
      let i = 1;
      selectedColums?.listViewSections.map(f => {
        f?.fields?.filter(f => f.enabled == true || f?.childFields?.length > 0)?.map(x => {
          //nested field
          if (x?.childFields?.length > 0) {
            x.childFields?.filter(n => n.enabled == true)?.map(nestObj => {
              columns.push(
                {
                  id: i + 1,
                  field: nestObj.columnName,
                  header: `${x.name}: ${nestObj.name}`,
                  fieldNameDB: nestObj.columnName,
                  dataType: nestObj.fieldDataType == 'DateTime' ? 'date' : (nestObj.fieldDataType == 'Number' || nestObj.fieldDataType == 'Decimal') && nestObj.name != 'Qty' ? 'number' : nestObj.fieldDataType == 'Money' ? 'currency' : 'string',
                  fieldDataType: nestObj.fieldDataType,
                  formControlType: nestObj?.formControlType,
                  isShow: nestObj.enabled,
                  isCommaSeperated: (this.selectedSearch?.objectId == ActivityModuleId) ? ActivityCommaSeparatedControls.includes(x.formControlType) : CommaSeparatedControls.includes(x.formControlType),
                  isCustom: nestObj.isCustom,
                  isDateWithTime: nestObj?.isDateWithTime || false,
                  isCsv: CSVControls.includes(x.formControlType)
                });
              i = i + 1;
            })
          }
          else {
            columns.push(
              {
                id: i + 1,
                field: x.columnName,
                header: x.name,
                fieldNameDB: x.columnName,
                dataType: x.fieldDataType == 'DateTime' ? 'date' : (x.fieldDataType == 'Number' || x.fieldDataType == 'Decimal') ? 'number' : x.fieldDataType == 'Money' ? 'currency' : 'string',
                fieldDataType: x.fieldDataType as any,
                formControlType: x?.formControlType,
                isShow: x.enabled,
                isCommaSeperated: (this.selectedSearch?.objectId == ActivityModuleId) ? ActivityCommaSeparatedControls.includes(x.formControlType) : CommaSeparatedControls.includes(x.formControlType),
                isCustom: x.isCustom,
                isDateWithTime: x?.isDateWithTime || false,
                isCsv: CSVControls.includes(x.formControlType)
              });
            i = i + 1;
          }
        });
      });
    }

    return columns;
  }

  getColumnSettingsForTable(selectedColums: SavedSearchNS.SavedSearchColumnSetting[]): any[] {
    let columns: ISavedSearchColumnModel[] = [];
    if (selectedColums) {
      let i = 1;
      selectedColums?.map(f => {
        f?.fields?.filter(f => f.isSelected == true)?.map(x => {
          //nested field
          if (x?.nestedFields?.length > 0) {
            x.nestedFields?.filter(n => n.isSelected == true)?.map(nestObj => {
              columns.push(
                {
                  id: i + 1,
                  field: this.prepareColumnNameFromCriteria(nestObj.criteriaUsed),
                  header: `${x.name}: ${nestObj.labelName}`,
                  fieldNameDB: nestObj.fieldName,
                  dataType: nestObj.fieldDataType == 'DateTime' ? 'date' : (nestObj.fieldDataType == 'Number' || nestObj.fieldDataType == 'Decimal') && nestObj.fieldName != 'Qty' ? 'number' : nestObj.fieldDataType == 'Money' ? 'currency' : 'string',
                  fieldDataType: nestObj.fieldDataType,
                  formControlType: nestObj?.formControlType,
                  isShow: nestObj.isSelected,
                  isCommaSeperated: nestObj.IsCommaSeperatedAndNumber,
                  isCustom: x.isCustom,
                  isDateWithTime: (!nestObj.isCustom && nestObj.fieldDataType == 'DateTime'),
                  isCsv: false
                });
              i = i + 1;
            })
          }
          else {
            columns.push(
              {
                id: i + 1,
                field: this.prepareColumnNameFromCriteria(x.criteriaUsed),
                header: x.labelName,
                fieldNameDB: x.fieldName,
                dataType: x.fieldDataType == 'DateTime' ? 'date' : (x.fieldDataType == 'Number' || x.fieldDataType == 'Decimal') ? 'number' : x.fieldDataType == 'Money' ? 'currency' : 'string',
                fieldDataType: x.fieldDataType as any,
                formControlType: x?.formControlType,
                isShow: x.isSelected,
                isCustom: x.isCustom,
                isDateWithTime: (!x.isCustom && x.fieldDataType == 'DateTime'),
                isCommaSeperated: x.IsCommaSeperatedAndNumber,
                isCsv: false
              });
            i = i + 1;
          }
        });
      });
    }

    return columns;
  }

  prepareColumnNameFromCriteria(str?: string) {
    return str?.length > 0 ? str[0].toLocaleLowerCase() + str.slice(1) : str;
  }

  close() {
    this.dialogClosed.emit();
  }

  showPredict() {
    if(this.savedSearchRowsCount <101 && !this.selectedWorkbookId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Unable to create prediction model: The number of records must be greater than 100.'     
    })
    return;
    } 
    this.selectedLabel = "predict";
    this.pageIndex = 2;
    if(this.selectedWorkbookId){
      this.getSavedWorkbookData();
    }
    else{
      this.getSavedData();
    }
  }

  showForecast(){
    if(this.savedSearchRowsCount <201 && !this.selectedWorkbookId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Unable to create Forecast model: The number of records must be greater than 200.'     
    })
    return;
    } 
    this.selectedLabel = "forecast";
    this.pageIndex = 2;
    if(this.selectedWorkbookId){
      this.getSavedWorkbookData();
    }
    else{
      this.getSavedData();
    }

  }

  changePredict() {
    this.showPredictionBtn = false;
    this.btnDisable = false;
  }
  forecastModel() {
    if (!this.selectedDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a date column for Forecasting'
      });
    } else if (!this.selectedPredict) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a column for Forecasting'
      });
    }
    else {
      this.btnDisable = true;
      this.isLoading = true;
    // Reset the timer when button is clicked
    setTimeout(() => {
      this.isLoading = false;
    }, 5000);
      this.forecastDtaModel();
    }
  }

  filterDateColumns() {
    this.dateColumns = this.columns.filter(column =>
      column.dataType === 'date' || column.fieldDataType === 'DateTime'
    );
    this.nonDateColumns = this.columns.filter(column =>
      column.dataType !== 'date' && column.fieldDataType !== 'DateTime'
    );
  }

  trainModel() {
    if (!this.selectedPredict) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'please select the column for prediction'
      });
    } else {
      this.btnDisable = true;
      this.isLoading = true;
    // Reset the timer when button is clicked
    setTimeout(() => {
      this.isLoading = false;
    }, 5000);
      this.predictDtaModel();
    }
  }

  predictionType: string;
  predictDtaModel() {
    let data: {
      savedSearchId: any,
      targetColumn: string
    }; 
   if(this.selectedWorkbookId){
   let  workbookColumn = {
      // savedSearchId: this.selectedWorkbookId,
      targetColumn: this.selectedPredict?.name
    };
     this.getWorkbookPridictionModal(workbookColumn);
   }
   else {
     data = {
      savedSearchId: this.selectedSearch.id,
      targetColumn: this.selectedPredict.header
    }
    this.savedSearchesService.saveSearchPredictionModel(data).subscribe({
      next: (response) => {
        if (response?.results) {
          this.predictionResult = response?.results;
          this.predictionType = this.predictionResult?.predictType;
          if (this.predictionResult?.evaluation){
            const dataSet = JSON.parse(this.predictionResult?.evaluation)
            this.data8 = dataSet.data
            this.layout8 = dataSet.layout
          }
          this.categoryList = this.predictionResult.category.map((data) => {
            return { name: data.categoryName }
          });
          this.selectedCategory = this.categoryList[0];
          this.predictionResultCategory = this.predictionResult.category[0];
          this.impact = this.predictionResultCategory.impact;
          this.predictionPerformanceBlock = this.predictionResultCategory.performanceBlock;
          this.predictionSegmentBlock = this.predictionResultCategory?.segment;
    if (this.predictionSegmentBlock && this.predictionSegmentBlock.length > 0) {
      this.predictionSegmentBlock = this.predictionSegmentBlock.map(
        (segment) => {
          if (segment?.plot) {
            const dataSet = JSON.parse(segment?.plot);
            return {
              ...segment,
              plotData: dataSet.data,
              plotLayout: dataSet.layout,
            };
          }
          return segment;
        }
      );
    }
          if (this.predictionPerformanceBlock?.distribution_plot) {
            const dataSet = JSON.parse(this.predictionPerformanceBlock?.distribution_plot)
            this.data5 = dataSet.data
            this.layout5 = dataSet.layout
          }
          if (this.predictionResultCategory?.evaluation?.prediction_performance) {
            const dataSet = JSON.parse(this.predictionResultCategory?.evaluation?.prediction_performance)
            this.data6 = dataSet.data
            this.layout6 = dataSet.layout
          }
          if (this.segment && this.segment.length > 0 && this.segment[0]?.plot) {
            const dataSet = JSON.parse(this.segment[0]?.plot)
            this.data7 = dataSet.data
            this.layout7 = dataSet.layout
          }
          if (this.predictionResult?.category?.[0]?.sampleRows?.Sample) {
          const sampleData = this.predictionResult.category[0].sampleRows.Sample;

          // Get column names
          this.sampleColumns = sampleData.map(item => item.name);

          // Transform data into row format
          const numberOfRows = sampleData[0].values.length;
          this.sampleRows = [];

          for (let i = 0; i < numberOfRows; i++) {
            const rowData: any = {};
            sampleData.forEach((column, colIndex) => {
              // Format date fields
              if (column.name.toLowerCase().includes('date')) {
                try {
                  const date = new Date(column.values[i]);
                  if (!isNaN(date.getTime())) {
                    rowData[column.name] = date.toLocaleDateString();
                  } else {
                    rowData[column.name] = column.values[i];
                  }
                } catch {
                  rowData[column.name] = column.values[i];
                }
              }
              // Format number fields
              else if (typeof column.values[i] === 'number') {
                rowData[column.name] = column.values[i].toLocaleString();
              }
              // Format currency fields (assuming Amount and Sub Total are currency)
              else if (column.name.includes('Amount') || column.name.includes('Sub Total')) {
                const numValue = parseFloat(column.values[i]);
                if (!isNaN(numValue)) {
                  rowData[column.name] = numValue.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  });
                } else {
                  rowData[column.name] = column.values[i];
                }
              }
              // Handle other fields
              else {
                rowData[column.name] = column.values[i];
              }
            });
            this.sampleRows.push(rowData);
          }
        }
        if (this.predictionResult?.category?.[0]?.prediction?.value) {
          this.predictionRows = this.predictionResult?.category?.[0]?.prediction?.value.map(value => ({
            value: value
          }));
        }
          this.predictionEstimation = this.predictionResultCategory.evaluation;
          this.factors = this.predictionResultCategory.factor;
          this.selectedImpact = this.impact[0];
          this.showPredictionBtn = true;
          this.btnDisable = false;
          if (response.results == null) {
            this.btnDisable = false;
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Prediction model has been saved successfully.'
          });
        } else if (response?.message && response?.results === null) {
          // Stop the loader and show the error message from the response
          this.btnDisable = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message
          });
        }
      },
      error: (error) => {
        this.btnDisable = false
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message ? error?.error?.Message : 'Prediction model has not been saved, please try again...'
        });
      }
    })
   }
 
  }

  getWorkbookPridictionModal(data){
    this.dynamicTableService.getWorkbookPredictionModel(this.selectedWorkbookId, data).subscribe({
      next: (response) => {
        if (response?.results) {
          this.predictionResult = response?.results;
          this.predictionType = this.predictionResult?.predictType;
          if (this.predictionResult?.evaluation){
            const dataSet = JSON.parse(this.predictionResult?.evaluation)
            this.data8 = dataSet.data
            this.layout8 = dataSet.layout
          }
          this.categoryList = this.predictionResult.category.map((data) => {
            return { name: data.categoryName }
          });
          this.selectedCategory = this.categoryList[0];
          this.predictionResultCategory = this.predictionResult.category[0];
          this.impact = this.predictionResultCategory.impact;
          this.predictionPerformanceBlock = this.predictionResultCategory.performanceBlock;
          this.predictionSegmentBlock = this.predictionResultCategory?.segment;
    if (this.predictionSegmentBlock && this.predictionSegmentBlock.length > 0) {
      this.predictionSegmentBlock = this.predictionSegmentBlock.map(
        (segment) => {
          if (segment?.plot) {
            const dataSet = JSON.parse(segment?.plot);
            return {
              ...segment,
              plotData: dataSet.data,
              plotLayout: dataSet.layout,
            };
          }
          return segment;
        }
      );
    }
          if (this.predictionPerformanceBlock?.distribution_plot) {
            const dataSet = JSON.parse(this.predictionPerformanceBlock?.distribution_plot)
            this.data5 = dataSet.data
            this.layout5 = dataSet.layout
          }
          if (this.predictionResultCategory?.evaluation?.prediction_performance) {
            const dataSet = JSON.parse(this.predictionResultCategory?.evaluation?.prediction_performance)
            this.data6 = dataSet.data
            this.layout6 = dataSet.layout
          }
          if (this.segment && this.segment.length > 0 && this.segment[0]?.plot) {
            const dataSet = JSON.parse(this.segment[0]?.plot)
            this.data7 = dataSet.data
            this.layout7 = dataSet.layout
          }
          if (this.predictionResult?.category?.[0]?.sampleRows?.Sample) {
          const sampleData = this.predictionResult.category[0].sampleRows.Sample;

          // Get column names
          this.sampleColumns = sampleData.map(item => item.name);

          // Transform data into row format
          const numberOfRows = sampleData[0].values.length;
          this.sampleRows = [];

          for (let i = 0; i < numberOfRows; i++) {
            const rowData: any = {};
            sampleData.forEach((column, colIndex) => {
              // Format date fields
              if (column.name.toLowerCase().includes('date')) {
                try {
                  const date = new Date(column.values[i]);
                  if (!isNaN(date.getTime())) {
                    rowData[column.name] = date.toLocaleDateString();
                  } else {
                    rowData[column.name] = column.values[i];
                  }
                } catch {
                  rowData[column.name] = column.values[i];
                }
              }
              // Format number fields
              else if (typeof column.values[i] === 'number') {
                rowData[column.name] = column.values[i].toLocaleString();
              }
              // Format currency fields (assuming Amount and Sub Total are currency)
              else if (column.name.includes('Amount') || column.name.includes('Sub Total')) {
                const numValue = parseFloat(column.values[i]);
                if (!isNaN(numValue)) {
                  rowData[column.name] = numValue.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  });
                } else {
                  rowData[column.name] = column.values[i];
                }
              }
              // Handle other fields
              else {
                rowData[column.name] = column.values[i];
              }
            });
            this.sampleRows.push(rowData);
          }
        }
        if (this.predictionResult?.category?.[0]?.prediction?.value) {
          this.predictionRows = this.predictionResult?.category?.[0]?.prediction?.value.map(value => ({
            value: value
          }));
        }
          this.predictionEstimation = this.predictionResultCategory.evaluation;
          this.factors = this.predictionResultCategory.factor;
          this.selectedImpact = this.impact[0];
          this.showPredictionBtn = true;
          this.btnDisable = false;
          if (response.results == null) {
            this.btnDisable = false;
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Prediction model has been saved successfully.'
          });
        } else if (response?.message && response?.results === null) {
          // Stop the loader and show the error message from the response
          this.btnDisable = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message
          });
        }
      },
      error: (error) => {
        this.btnDisable = false
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message ? error?.error?.Message : 'Prediction model has not been saved, please try again...'
        });
      }
    })
  }
  formatPredictionValue(value: number): string {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  getSegmentColor(segmentName: string): string {
    switch (segmentName.toLowerCase()) {
      case 'high':
        return 'bg-green';
      case 'medium':
        return 'bg-yellow';
      case 'low':
        return 'bg-red';
      default:
        return 'bg-purple';
    }
  }

  addNewPredictionData(formData: any) {
    this.userInputRows.push(formData.rowData);
    this.userPredictionRows.push(formData.inferenceData[0]);
  }

  forecastingType: string;
  forecastDtaModel(){
    let mata: {
      savedSearchId: number,
      targetColumn: string,
      dateColumn: string
    };
      if(this.selectedWorkbookId) {
        let workbookForecastColumn = {
          // savedSearchId: this.selectedSearch.id,
        targetColumn: this.selectedPredict?.name,
        dateColumn: this.selectedDate?.name
        }
        this.getWorkbookForecastModal(workbookForecastColumn);
      }
      else {
        mata = {
          savedSearchId: this.selectedSearch.id,
          targetColumn: this.selectedPredict?.header,
          dateColumn: this.selectedDate?.header
        }
        this.savedSearchesService.saveSearchForecastingModel(mata).subscribe({
          next: (response) => {
            if (response?.results) {
              this.forecastResult = response?.results;
              this.forecastingType = this.forecastResult?.predictType;
              this.forecastingResultCategory = this.forecastResult.category[0];
              this.showPredictionBtn = true;
              if (this.forecastingResultCategory?.firstBlock?.forecasting) {
                const dataSet= JSON.parse(this.forecastingResultCategory?.firstBlock?.forecasting)
                this.data = dataSet.data
                this.layout = dataSet.layout
              }
              this.secondForecasting = this.forecastingResultCategory?.secondBlock;
              if (this.secondForecasting?.plot) {
                const dataSet = JSON.parse(this.secondForecasting?.plot)
                this.data1 = dataSet.data
                this.layout1 = dataSet.layout
              }
              this.thirdForecasting = this.forecastingResultCategory?.thirdBlock;
              if (this.thirdForecasting?.future_forecasting) {
                const dataSet = JSON.parse(this.thirdForecasting?.future_forecasting)
                this.data2 = dataSet.data
                this.layout2 = dataSet.layout
              }
              this.fourthForecasting = this.forecastingResultCategory?.fourthBlock;
              this.futureArray = this.fourthForecasting?.future_values;
              this.futureArray = Object.keys(this.futureArray).map((date) => ({
                date: date,
                value: this.futureArray[date],
              }));
              this.section5 = this.fourthForecasting?.seasonality;
              if (this.section5?.monthly) {
                const dataSet = JSON.parse(this.section5?.monthly)
                this.data3 = dataSet.data
                this.layout3 = dataSet.layout
              }
              if (this.section5?.quarterly) {
                const dataSet = JSON.parse(this.section5?.quarterly)
                this.data4 = dataSet.data
                this.layout4 = dataSet.layout
              }
            } else if (response?.message && response?.results === null) {
              // Stop the loader and show the error message from the response
              this.btnDisable = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.message
              });
            }
          },
          error: (error) => {
            this.btnDisable = false
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.Message : 'Prediction model has not been saved, please try again...'
            });
          }
        })
    }
  }

  getWorkbookForecastModal(data) {
    this.dynamicTableService.getWorkbookForecastModel(this.selectedWorkbookId, data).subscribe({
      next: (response) => {
        if (response?.results) {
          this.forecastResult = response?.results;
          this.forecastingType = this.forecastResult?.predictType;
          this.forecastingResultCategory = this.forecastResult.category[0];
          this.showPredictionBtn = true;
          if (this.forecastingResultCategory?.firstBlock?.forecasting) {
            const dataSet= JSON.parse(this.forecastingResultCategory?.firstBlock?.forecasting)
            this.data = dataSet.data
            this.layout = dataSet.layout
          }
          this.secondForecasting = this.forecastingResultCategory?.secondBlock;
          if (this.secondForecasting?.plot) {
            const dataSet = JSON.parse(this.secondForecasting?.plot)
            this.data1 = dataSet.data
            this.layout1 = dataSet.layout
          }
          this.thirdForecasting = this.forecastingResultCategory?.thirdBlock;
          if (this.thirdForecasting?.future_forecasting) {
            const dataSet = JSON.parse(this.thirdForecasting?.future_forecasting)
            this.data2 = dataSet.data
            this.layout2 = dataSet.layout
          }
          this.fourthForecasting = this.forecastingResultCategory?.fourthBlock;
          this.futureArray = this.fourthForecasting?.future_values;
          this.futureArray = Object.keys(this.futureArray).map((date) => ({
            date: date,
            value: this.futureArray[date],
          }));
          this.section5 = this.fourthForecasting?.seasonality;
          if (this.section5?.monthly) {
            const dataSet = JSON.parse(this.section5?.monthly)
            this.data3 = dataSet.data
            this.layout3 = dataSet.layout
          }
          if (this.section5?.quarterly) {
            const dataSet = JSON.parse(this.section5?.quarterly)
            this.data4 = dataSet.data
            this.layout4 = dataSet.layout
          }
        } else if (response?.message && response?.results === null) {
          // Stop the loader and show the error message from the response
          this.btnDisable = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message
          });
        }
      },
      error: (error) => {
        this.btnDisable = false
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message ? error?.error?.Message : 'Prediction model has not been saved, please try again...'
        });
      }
    })
  }

  onSelectedCategory(event) {
    this.predictionResultCategory = this.predictionResult.category.find((data) => {
      return data.categoryName == event.value.name;
    });
    this.impact = this.predictionResultCategory.impact;
    this.predictionPerformanceBlock = this.predictionResultCategory.performanceBlock;
    this.predictionEstimation = this.predictionResultCategory.evaluation;
    this.selectedImpact = this.impact[0];
  }

  onSelctedImpact(impact) {
    this.selectedImpact = impact;
  }

}
